// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1VxEE","sendOtp":"AuthorizeToLogin_sendOtp__1yyUm"};